import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import React from 'react';

import { useFooterContext, useAppConfig } from '../../hooks';
import { extractChildrenWithNavigationType, extractFooterNavigationType } from '../../utils';
import { ContentCaption } from './ContentCaption';
import { ContentRoot } from './ContentRoot';

export const ContentFrontPage: React.FC = () => {
  const { data } = useFooterContext();
  const { isFrontPage } = useAppConfig();

  const footer = extractFooterNavigationType(data);
  const bottom = extractChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.Bottom, footer);

  if (!isFrontPage) {
    return null;
  }

  return (
    <ContentRoot>
      <ContentCaption>{bottom?.title}</ContentCaption>
    </ContentRoot>
  );
};
